export const NOT_FOUND_ERROR_CODES = {
  user: "5025",
  brand: "5235",
  community: "5218",
  group: "5168",
  video: "5209",
} as const;

export const NOT_FOUND_ERROR_MESSAGES = {
  user: {
    title: "User not found",
    description:
      "We're sorry, but the user you are looking for no longer exists.",
    showButton: true,
  },
  brand: {
    title: "Brand not found",
    description:
      "We're sorry, but the brand you are looking for no longer exists.",
    showButton: true,
  },
  community: {
    title: "Community not found",
    description:
      "We're sorry, but the community you are looking for no longer exists.",
    showButton: true,
  },
  group: {
    title: "Group not found",
    description:
      "We're sorry, but the group you are looking for no longer exists.",
    showButton: true,
  },
  video: {
    title: "Video not found",
    description: "We're sorry, but this video no longer exists.",
    showButton: true,
  },
} as const;
